// @flow

/**
 * User Message Body Component
 * Renders user message text with proper formatting
 */

import React from 'react';

const UserMessageBody = ({ text }) => {
  return (
    <pre style={{ 
      margin: 0, 
      whiteSpace: 'pre-wrap', 
      fontFamily: 'var(--fonts-default)' 
    }}>
      {text}
    </pre>
  );
};

export default UserMessageBody;
